/**
 * In the preview, a link to a page of the Keepo (`/contato`, the menu's) would load the editor's own address
 * inside the preview's frame. Those clicks don't navigate it; `onPageLink` is told the address instead, so the
 * preview can show that page. Links to other sites keep working. Returns the cleanup.
 */
export const blockPageLinks = (doc: Document, onPageLink?: (path: string) => void): (() => void) => {
  const onClick = (event: MouseEvent) => {
    const href = (event.target as Element | null)?.closest?.("a[href]")?.getAttribute("href");
    if (href?.startsWith("/")) {
      event.preventDefault();
      onPageLink?.(href);
    }
  };

  doc.addEventListener("click", onClick, true);
  return () => doc.removeEventListener("click", onClick, true);
};
